// Rows for the weekly rollup table below the Direct Labor table — labels match the CLIN sheet
// (Sweet Tooth EAC) exactly, including where CPFF and FFP use different wording for the same row;
// labelByType overrides the default `label` for a specific contract type. Use getRowLabel(row,
// type) to resolve the label actually shown.
// mode "sum": additive per-week amount, summed across the matching weeks for ITD/Remaining
// Forecast/Total. mode "lastValue": a running/cumulative figure — ITD and Total take the value
// as of the last actual/last week, Remaining Forecast is the delta between them.
export const WEEKLY_SUMMARY_ROWS = [
  {
    key: "totalLaborDollars",
    label: "Total Labor Dollars (fully burdened)",
    format: "currency",
    mode: "sum",
  },
  {
    key: "creditOverCeilingRate",
    label: "Credit for Over Ceiling Rate",
    format: "currency",
    mode: "sum",
  },
  {
    key: "fixedMonthlyMilestone",
    label: "Monthly Invoiced Fee",
    format: "currency",
    mode: "sum",
  },
  {
    key: "billableCosts",
    label: "Billable Costs (Costs Plus Ceiling Overages)",
    format: "currency",
    mode: "lastValue",
  },
  {
    key: "reserveOnCosts",
    label: "Reserve on Costs Only (Billable Costs Only)",
    format: "currency",
    mode: "sum",
  },
  {
    key: "cumulativeCostAndReserve",
    label: "Cumulative Cost, Fee, Overages, and Reserve",
    labelByType: { FFP: "Cumulative Cost and Reserve" },
    format: "currency",
    mode: "lastValue",
  },
  {
    key: "estimatedProfitPercent",
    label: "Estimated Profit %",
    format: "percent",
    mode: "lastValue",
  },
  {
    key: "fundingRemainingBasedOnMilestones",
    label: "Funding Remaining Based on Milestones",
    format: "currency",
    mode: "lastValue",
    hideForType: "Cost Plus",
  },
  {
    key: "fundingRemainingBasedOnCosts",
    label: "Funding Remaining Based on Costs",
    format: "currency",
    mode: "lastValue",
  },
  {
    key: "limitationOfCeilingPercentage",
    label: "Limitation of Ceiling Percentage",
    labelByType: { FFP: "Limitation of Cost Percentage" },
    format: "percent",
    mode: "lastValue",
  },
  {
    key: "limitationOfFundingPercentage",
    label: "Limitation of Funding Percentage",
    format: "percent",
    mode: "lastValue",
  },
];

export const getRowLabel = (row, type) => row.labelByType?.[type] || row.label;
